import { Expose, Transform, Type } from 'class-transformer';
import { Model } from './model';
import { BasicUser } from './basic-user-model';
import { FileType } from '../../common';

export class ContactUsMessageDetails extends Model {
  @Expose() id: string;
  @Expose() content: string;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  date: Date;
  @Expose() file: string;
  @Expose() fileType: FileType;
  @Expose()
  @Type(() => BasicUser)
  sender: BasicUser;
}
